module.exports = __webpack_public_path__ + "img/_austria.af540ae7.png";